// Date-only strings ('2026-07-09') parse as UTC midnight in JS, which
// shifts them to the previous day in any US timezone. Everything in the
// marketing section that reads publishDate / closedDate / createdDate
// must parse through here so a Thursday publish stays on Thursday and a
// Jan 1 win stays in the right year.

export function parseLocalDate(value) {
  if (!value) return null;
  if (typeof value === 'string') {
    // Accept bare 'YYYY-MM-DD' and full ISO timestamps alike: for
    // date-only semantics the calendar date IS the value, so take it
    // as-is rather than letting a 'T00:00:00.000Z' suffix shift it to
    // the previous local day.
    const m = value.match(/^(\d{4})-(\d{2})-(\d{2})([T\s]|$)/);
    if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  }
  return new Date(value);
}

// Client mirror of rangeWindow in lib/ga4Analytics.js — the pipeline-side
// funnel steps (new prospects, closed-won) must cover the same days as
// the GA4 top of the funnel. Keep in lockstep with the server.
export function rangeWindow(range = '30d', now = new Date()) {
  const end = new Date(now);
  end.setHours(23, 59, 59, 999);
  const start = new Date(now);
  start.setHours(0, 0, 0, 0);
  if (range === '7d') start.setDate(start.getDate() - 6);
  else if (range === '90d') start.setDate(start.getDate() - 89);
  else if (range === 'qtd') {
    start.setMonth(Math.floor(start.getMonth() / 3) * 3, 1);
  } else start.setDate(start.getDate() - 29); // default 30d
  return { start, end };
}
